export const env = {
    endpoint: window.location.protocol + '//' + process.env.REACT_APP_BASE_URL,
    bidder: window.location.protocol + '//' + process.env.REACT_APP_BIDDER_URL,
    bucket: process.env.REACT_APP_BUCKET_URL,
    mapsApiKey: process.env.REACT_APP_MAPS_API_KEY
}


// WEBPACK FOOTER //
// ./src/env/index.ts